import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import NotificationButton from "../components/notification/NotificationButton";
import DarkModeButton from "../components/common/dark_mode/DarkModeButton";
import { useLayout } from "../hooks/context/useLayout";
import CypherLeakLogo from "../components/common/logo/CypherLeakLogo";
import ProfileActions from "./ProfileActions";
import ProfileWidget from "./ProfileWidget";
import { useOrgApp } from "../hooks/context/useOrgApp";
import { poweredByOrgs } from "../data/poweredByOrgs";
import { defaultRoute } from "../data/global";
import useModules from "../hooks/services/profile/useModules";

const SideBar = () => {
  const { orgApp: { organisationId }, isSelectedOrg } = useOrgApp();
  const { modules } = useModules();
  const { toggleSideBar, closeSideBar } = useLayout();
  const location = useLocation();

  const path = location.pathname;
  const poweredByLogo: string | undefined = poweredByOrgs.includes(organisationId) ?
    `${process.env.PUBLIC_URL}/logos/logo${organisationId}.png` : undefined;
  
  return (
    <div className="nav-dashboard">
      <div className="content-nav-dashboard">
        {/* Logo/Link */}
        <div className="logo-dashboard">
          <Link to={isSelectedOrg() ? "/" : defaultRoute}>
            <CypherLeakLogo src={poweredByLogo} />
          </Link>
        </div>

        <div className="right-nav-mobile">
          {/* toggle button dark mode (mobile) */}
          <DarkModeButton isMobile />

          {/* notification button for mobile */}
          <NotificationButton isMobile />

          {/* sidebar button */}
          <button className="navbar-toggler" type="button" onClick={toggleSideBar}>
            <div className="bar-tnav-toggler">
              <span />
              <span />
              <span />
            </div>
          </button>
        </div>

        <div className="menu-nav-dashboard">
          {/* Profile Preview (Desktop) */}
          <div className="bloc-profile-header hidden-desktop">
            <div className="profile-menu-header">
              <ProfileWidget />
            </div>
          </div>

          {/* NavBar Items */}
          <ul className="navbar">
            {/* show only the nav links in the dashboard means the link who have an icon */}
            {/* hide links when no org  */}
            {isSelectedOrg() &&
                modules.filter((module) => module.fromSideBar).map((module, index) => (
                  // Organization ID 14 for demo account | Disable Dark Module for all Ogrs except demo
                  <li key={index} onClick={closeSideBar}
                    className={classNames({ "nav-item": true, active: module.path === path })}
                  >
                    <Link to={module.path} className="nav-link user-select-none">
                      {module.Icon && <module.Icon />}
                      <span>{module.name}</span>
                    </Link>
                  </li>
                ))}
          </ul>

          {/* Profile/Logout Section (Mobile)*/}
          <div className="profile-menu-header">
            <ProfileActions show={true} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
